import { graphql, Link, useStaticQuery } from 'gatsby';
import React, { useState } from 'react'
import useScrollPercentage from '../hooks/useScrollPercentage';
import MobileMenu from './MobileMenu';
import { FaCheck, FaPhone } from 'react-icons/fa'

function Header(props)
{
  const data = useStaticQuery(graphql`
    query HeaderQuery{
      datoCmsDefault {
        id
        logo {
          url
        }
        usp {
          value
        }
        phone
        headermenu {
          menu{
            ... on DatoCmsBlockMenuItem {
              title
              url {
                slug
                name
              }
            }
          }
        }
      }
      datoCmsMenuWidget(name: {eq: "Header menu"}) {
        id
        menu{
          ... on DatoCmsBlockMenuItem {
            id
            model {
              apiKey
            }
            title
            url {
              slug
              name
            }
          }
        }
      }
    }
  `)

  const [active, setActive] = useState(false)

  const scroll = useScrollPercentage()

  const belowMenuText = data.datoCmsDefault.usp.value.document.children[0].children.map(child =>
    child.children[0].children[0].value
  )

  return (
    <>
      <div className={`sticky top-0 z-20 bg-white px-4 md:px-8  `}>
        <div className="max-w-8xl flex flex-row mx-auto  pt-8 pb-0">
          <div className="w-24 sm:w-36 md:w-72 flex flex-row justify-between ">
            <div className={`hidden md:block border-b border-orange w-20 transition-all transform origin-left
            ${scroll > 0.05 && "scale-x-250"}
            `
            }
            // style={{ transition: "margin-right 0.3s", marginRight: `${scroll > 0.05 ? "0em" : "7em"}` }}
            />
            <Link to="/">
              <img
                // src="https://werkbaanoost.nl/wp-content/themes/werkbaanoost/images/logo-wbo.svg"
                src={data.datoCmsDefault.logo.url}
                className={`h-24 mr-0 ml-auto transition-all duration-300 origin-bottom-right transform ${scroll > 0.05 ? " translate-y-0 lg:scale-75" : " scale-100 md:scale-125 md:translate-y-4 lg:scale-200 lg:translate-y-28"}`}
                alt="logo"
                width="100px"
                height="100px"
              />
            </Link>
          </div>
          <div className="flex flex-col items-end flex-grow">
            <div>
              <a className="text-orange font-extrabold text-xs sm:text-base" href={`tel:${data.datoCmsDefault.phone}`}>
                <FaPhone className="text-blue mr-2.5 inline-block" />
                {data.datoCmsDefault.phone}
              </a>
            </div>
            <nav className="border-b border-blue w-full">
              <div className="hidden lg:block">
                <ul className="flex flex-row justify-end">
                  {data.datoCmsMenuWidget.menu.map((item) => (
                    <li key={item.title} className="py-7 pl-7 font-bold text-lg uppercase">
                      <Link to={"/" + item.url.slug} className="text-blue hover:text-orange">{item.title}</Link>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="flex justify-end lg:hidden">
                <button
                  type="button"
                  className=" p-6 rounded-md text-blue focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                  aria-controls="mobile-menu"
                  aria-expanded="false"
                  onClick={() => setActive(true)}
                >
                  <span className="sr-only">Open main menu</span>
                  <svg className="block h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
                  </svg>
                </button>
              </div>
              <MobileMenu menu={data.datoCmsMenuWidget.menu} active={active} handleClose={() => setActive(false)} />
            </nav>
            {/* <div className={`hidden md:block transform transition-all overflow-y-hidden ${scroll > 0.05 && "scale-y-0"}`}>
              <ul className="flex flex-row">
                {belowMenuText.map(item => (
                  <li key={item} className="py-7 pl-7">
                    <i className="fas fa-check text-orange mr-2.5" />{item}
                  </li>
                ))}
              </ul>
            </div> */}
          </div>

        </div>
      </div>
      <div className={` hidden lg:block bg-white`}>
        <ul className="flex flex-row justify-end max-w-8xl mx-auto px-8">
          {belowMenuText.map(item => (
            <li key={item} className="py-7 pl-7">
              <FaCheck className="text-orange mr-2.5 inline-block" />
              {/* <i className="fas fa-check text-orange mr-2.5" /> */}
              {item}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Header;